module.exports = __webpack_public_path__ + "img/reject-dm.29c54b0c.svg";